"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var BusinessOutlined_1 = __importDefault(require("@mui/icons-material/BusinessOutlined"));
var EmailOutlined_1 = __importDefault(require("@mui/icons-material/EmailOutlined"));
var EmojiFlagsOutlined_1 = __importDefault(require("@mui/icons-material/EmojiFlagsOutlined"));
var LocationOnOutlined_1 = __importDefault(require("@mui/icons-material/LocationOnOutlined"));
var PersonOutline_1 = __importDefault(require("@mui/icons-material/PersonOutline"));
var PhoneOutlined_1 = __importDefault(require("@mui/icons-material/PhoneOutlined"));
var Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
var PublicOutlined_1 = __importDefault(require("@mui/icons-material/PublicOutlined"));
var LocationCityOutlined_1 = __importDefault(require("@mui/icons-material/LocationCityOutlined"));
var SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
var CheckIcon = function (_a) {
    var style = _a.style;
    return ((0, jsx_runtime_1.jsx)(SvgIcon_1.default, { style: style, viewBox: "0 0 22 22", children: (0, jsx_runtime_1.jsx)("path", { d: "M11,22c6.1,0,11-4.9,11-11c0-6.1-4.9-11-11-11C4.9,0,0,4.9,0,11C0,17.1,4.9,22,11,22z M15.6,6.3L17,7.7l-8,8\n          l-4-4l1.4-1.4L9,12.9L15.6,6.3z" }) }));
};
var icons = {
    company: BusinessOutlined_1.default,
    email: EmailOutlined_1.default,
    invalid: Cancel_1.default,
    phone: PhoneOutlined_1.default,
    person: PersonOutline_1.default,
    state: EmojiFlagsOutlined_1.default,
    valid: CheckIcon,
    zipcode: LocationOnOutlined_1.default,
    locationService: LocationOnOutlined_1.default,
    city: LocationCityOutlined_1.default,
    globe: PublicOutlined_1.default,
};
exports.default = icons;
//# sourceMappingURL=icons.js.map